import {
  login,
  logout,
  request,
  getRequests,
  review,
  getReviews,
  addIssue,
  myRequests,
  quota,
  plexAuth,
  getArchive,
} from "./actions";

export default {
  login,
  logout,
  request,
  getRequests,
  review,
  getReviews,
  addIssue,
  myRequests,
  quota,
  plexAuth,
  getArchive,
};
